import React from 'react';
import { Row, Col } from 'react-bootstrap';

import FieldSelect from './FieldSelect.jsx';
import FieldSelectDriveability from './FieldSelectDriveability.jsx';
import FieldSelectTrackCondition from './FieldSelectTrackCondition.jsx';
import FieldSelectWeatherCondition from './FieldSelectWeatherCondition.jsx';
import FieldTextBox from './FieldTextBox.jsx';

export default function PracticeDetails() {
  const practiceLengthTime = [10, 20, 30].map(time => ({ slug: time, value: `${time} min` }));

  return (
    <div id="section-practice-details">
      <h4 className="rating-type">Practice</h4>

      <Row>
        <Row className="no-margin">
          <Col sm={3} xs={12}>
            <FieldTextBox placeholder="Time (e.g. 12:00PM)" field="timeOfDay" />
          </Col>
          <Col sm={3} xs={12}>
            <FieldSelect options={practiceLengthTime} field="practiceLengthTime" defaultEmptyOption="Practice Length" />
          </Col>
          <Col sm={3} xs={12}>
            <FieldTextBox placeholder="Laps Completed" field="approxLapsCompleted" />
          </Col>
          <Col sm={3} xs={12}>
            <FieldTextBox placeholder="Expected Qualifying Position" field="expectedQualifyPosition" />
          </Col>
        </Row>
        <Row className="no-margin">
          <Col sm={6} xs={12}>
            <FieldSelectWeatherCondition defaultEmptyOption="Weather Condition" />
          </Col>
          <Col sm={6} xs={12}>
            <FieldTextBox placeholder="Temperature" field="weatherTemperature" />
          </Col>
        </Row>
        <Col xs={12} sm={6}>
          <FieldSelectTrackCondition defaultEmptyOption="Track Condition" />
        </Col>
        <Col xs={12} sm={6}>
          <FieldSelectDriveability defaultEmptyOption="Track Driveability" />
        </Col>
      </Row>
    </div>
  );
}
